export function getIsJavaScriptEnabled(): boolean {
  let isJavaScriptEnabled = true;

  if (typeof window !== 'undefined' && window.document)
    isJavaScriptEnabled = true;
  else isJavaScriptEnabled = false;

  return isJavaScriptEnabled;
}
